/** @format */

import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { CustomHttpHeaders, MediaType } from '@shared/data-access/enums';
import { Environment } from '@shared/data-access/interfaces';
import { throwError } from 'rxjs';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { AvailableWarrantiesBody, AvailableWarrantiesResponse } from '@pdp/data-access/interfaces';

@Injectable({ providedIn: 'root' })
export class NonMerchAvailabilityDao {
	http = inject(HttpClient);
	environment = inject(Environment);

	private readonly DEFAULT_HTTP_HEADER_PROPERTIES = {
		Accept: MediaType.APPLICATION_JSON,
		// eslint-disable-next-line @typescript-eslint/naming-convention
		'Content-Type': MediaType.APPLICATION_JSON
	};

	public getAvailableWarranties(body: AvailableWarrantiesBody) {
		if (!this.environment.api.nonmerch?.proxy) {
			return throwError(
				() => new Error('Nonmerch service urls not configured for current environment')
			);
		}

		const httpOptions = {
			headers: {
				...this.DEFAULT_HTTP_HEADER_PROPERTIES,
				[CustomHttpHeaders.X_TIMEOUT]: `${this.environment.api.nonmerch.proxy.timeout}`
			}
		};

		return this.http.post<AvailableWarrantiesResponse>(
			`${this.environment.api.nonmerch.proxy.path}/available/warranties`,
			body,
			httpOptions
		);
	}
}
